import React from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/site";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";

export default function ServiceDetail() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return (
    <div className="pt-40 pb-40 text-center container-lux">
      <h1 className="text-3xl text-white font-light">Service not found</h1>
      <Link to="/services" className="btn-outline mt-8 inline-flex">Back to Services</Link>
    </div>
  );
  return (
    <div data-testid="service-detail-page">
      <Seo
        title={`${s.title} in Naples, Bonita Springs & Fort Myers | K.O Chef & Catering`}
        description={`${s.tag}. ${s.desc}`.slice(0, 300)}
        path={`/services/${s.slug}`}
        image={s.image}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": s.title,
          "serviceType": s.title,
          "description": s.desc,
          "provider": { "@type": "Caterer", "name": "K.O CHEF & CATERING LLC", "url": "https://kochefcatering.com/" },
          "areaServed": ["Naples, FL", "Bonita Springs, FL", "Fort Myers, FL", "Southwest Florida"],
          "url": `https://kochefcatering.com/services/${s.slug}`,
        }}
      />
      <PageHero overline="Catering Service" title={s.title} subtitle={s.tag} image={s.image} />
      <section className="py-20 md:py-28">
        <div className="container-lux grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <Reveal><img src={s.image} alt={s.title} className="w-full h-[480px] object-cover" /></Reveal>
          <Reveal delay={0.15}>
            <p className="overline mb-4">The Experience</p>
            <h2 className="text-4xl font-light text-white mb-6 leading-tight">{s.tag}</h2>
            <p className="text-white/60 leading-relaxed mb-8">{s.desc}</p>
            <ul className="space-y-4 mb-10">
              {s.features.map((f) => (
                <li key={f} className="flex items-center gap-3 text-white/75"><Check className="w-5 h-5 text-gold shrink-0" />{f}</li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/request-a-quote" className="btn-gold" data-testid="service-quote-btn">Request a Quote</Link>
              <Link to="/build-your-menu" className="btn-outline" data-testid="service-build-btn">Build Your Menu</Link>
            </div>
          </Reveal>
        </div>
      </section>
      <section className="pb-24">
        <div className="container-lux">
          <Link to="/services" className="text-gold text-sm uppercase tracking-widest flex items-center gap-2 hover:gap-4 transition-all"><ArrowLeft className="w-4 h-4" /> All Services</Link>
        </div>
      </section>
    </div>
  );
}
